import React from 'react'
import { Link } from "react-router-dom";
import '../css/equipaje.scss'
import Breadcrumbs from './Breadcrumbs';
import Footer from './Footer';

export default function Equipaje() {
    return (
        <>
            <main className="equipaje">

                {/* Hero Section */}
                 
                  {/* HERO */}
                <div className='recepcion-equipaje-hero'>

                    <div className='overlay'></div>

                    <div className='container hero-content'>

                        <div style={{ marginTop: '4rem' }}>
                            <Breadcrumbs />
                        </div>

                        <h1>
                            Recepción de equipaje
                        </h1>

                        <p>
                            Bienvenido a su destino. Siga nuestras sencillas instrucciones
                            para una entrega de equipaje rápida y segura.
                        </p>

                    </div>

                </div>

                {/* Content */}
                <section className="content-section">
                    <div className="container content-grid">

                        {/* Main Column */}
                        <div className="main-column">

                            {/* Step 1 */}
                            <div className="info-card">
                                <div className="step-number">
                                    1
                                </div>

                                <div className="card-content">
                                    <h3>Diríjase al área de equipaje</h3>

                                    <p>
                                        Una vez que haya ingresado a la terminal tras su
                                        desembarque, debe dirigirse directamente a la zona
                                        señalizada como <strong>Recepción de Equipaje</strong>.
                                        Nuestro sistema logístico garantiza que sus pertenencias
                                        lleguen de manera segura al punto de entrega designado.
                                    </p>
                                   
                                </div>
                            </div>

                            {/* Step 2 */}
                            <div className="info-card">
                                <div className="step-number">
                                    2
                                </div>

                                <div className="card-content">
                                    <h3>Presente su boleto</h3>

                                    <p>
                                        Para garantizar que cada maleta sea entregada a su
                                        legítimo dueño, el personal de Baja Ferries le solicitará
                                        su <strong>boleto de viaje</strong> o comprobante de
                                        equipaje original. Por favor, téngalo a la mano al momento
                                        de llegar al mostrador.
                                    </p>

                                   
                                </div>
                            </div>

                        </div>

                        {/* Sidebar */}
                        <div className="sidebar-column">

                            {/* Support Card */}
                            <div className="support-card">

                                <div className="support-circle"></div>

                                <div className="support-content">
                                    <span className="material-symbols-outlined support-icon fill">
                                        <i class="fi fi-rs-vest-patches"></i>
                                    </span>

                                    <h4>¿Necesita asistencia?</h4>

                                    <p>
                                        Para cualquier duda o aclaración sobre su equipaje,
                                        puede acercarse con confianza a nuestro
                                        <strong> personal con chaleco amarillo</strong>.
                                    </p>

                                    <div className="support-footer">
                                        <span className="material-symbols-outlined">
                                            <i class="fi fi-rs-shield-check"></i>
                                        </span>

                                        <span>Personal certificado</span>
                                    </div>
                                </div>
                            </div>

                            {/* FAQ 
                            <div className="faq-card">
                                <h4>Preguntas frecuentes</h4>

                                <ul>

                                    <li>
                                        <Link to="/">
                                            <span>Equipaje extraviado</span>

                                            <span className="material-symbols-outlined small">
                                                <i class="fi fi-rs-arrow-small-right"></i>
                                            </span>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/">
                                            <span>Objetos prohibidos</span>

                                            <span className="material-symbols-outlined small">
                                                <i class="fi fi-rs-arrow-small-right"></i>
                                            </span>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/">
                                            <span>Límites de peso</span>

                                            <span className="material-symbols-outlined small">
                                                <i class="fi fi-rs-arrow-small-right"></i>
                                            </span>
                                        </Link>
                                    </li>

                                </ul>
                            </div>
                            */}
                        </div>

                    </div>
                </section>

                {/* Help Section */}
                <section className="help-section">

                    <div className="container help-container">

                        <span className="help-label">
                            Atención al Cliente
                        </span>

                        <h2>
                            Estamos aquí para ayudarle
                        </h2>

                        <div className="help-grid">

                            <div className="help-card">
                                <span className="material-symbols-outlined">
                                    <i class="fi fi-rs-user-headset"></i>
                                </span>

                                <h5>Llámenos</h5>

                                <p>800 337 7437</p>
                            </div>

                            <div className="help-card">
                                <span className="material-symbols-outlined">
                                    <i class="fi fi-rs-envelope"></i>
                                </span>

                                <h5>Correo electrónico</h5>

                                <p>contactcenter@bajaferries.com.mx</p>
                            </div>

                            <div className="help-card">
                                <span className="material-symbols-outlined">
                                    <i class="fi fi-rs-messages"></i>
                                </span>

                                <h5>Chatbot</h5>

                                <p>Disponible 24/7</p>
                            </div>

                        </div>
                    </div>
                </section>

            </main>
            <Footer />
        </>
    )
}